export default __webpack_public_path__ + "static/media/send.655a1b4b.svg";